// extracted by mini-css-extract-plugin
export default {"wrapper":"Volume_wrapper__doZJO","slider":"Volume_slider__uP3ci"};